module.exports = __webpack_public_path__ + "static/016-f425d2c3131d2bf7070bc96002e0bcac.jpg";